import { useQuery } from '@tanstack/react-query';
import { http } from '@/shared/api/client';
import { useAuthStore } from '@/shared/auth/auth-store';

export type BusinessType = 'retail' | 'restaurant' | 'mixed';
export function useBusinessProfile() {
  const token = useAuthStore(s => s.token);
  return useQuery({
    queryKey: ['business-profile'], enabled: !!token,
    queryFn: async () => (await http.get<{business_type: BusinessType}>('/api/business-profile')).data,
    staleTime: 60_000,
  });
}
export function useRestaurantEnabled() {
  const { data } = useBusinessProfile();
  return data?.business_type === 'restaurant' || data?.business_type === 'mixed';
}
